import { lazy } from 'react';

// Public pages — auth-v2 only. The legacy LoginPage / MFAPage / RecoveryPage
// were removed in step 23 of the auth-perfection plan. Rollback is via git
// history if ever needed.
export const SigninApp = lazy(() =>
  import('@/platform/authentication/pages/SigninApp').then((m) => ({ default: m.SigninApp }))
);

export const RecoveryApp = lazy(() =>
  import('@/platform/authentication/pages/RecoveryApp').then((m) => ({ default: m.RecoveryApp }))
);

export const FirstTimeApp = lazy(() =>
  import('@/platform/authentication/pages/FirstTimeApp').then((m) => ({ default: m.FirstTimeApp }))
);

export const OAuthCallback = lazy(() =>
  import('@/platform/authentication/pages/OAuthCallback').then((m) => ({ default: m.OAuthCallback }))
);

export const LicenseSuspended = lazy(() =>
  import('@/platform/authentication/pages/LicenseSuspended').then((m) => ({ default: m.LicenseSuspended }))
);

// MFA helper — PIN-setup is still its own page (post-MFA, pre-app).
export const PinSetupPage = lazy(() =>
  import('@/platform/authentication/pages/PinSetupPage').then((m) => ({ default: m.PinSetupPage }))
);
